function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FF9800",
  d: "M8 10.001H25V27.000999999999998H8z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#FF9800",
  d: "M7.661 9.661H25.339V27.339H7.661z",
  transform: "rotate(-45.001 16.5 18.5)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFEB3B",
  d: "M10,18.5c0,3.591,2.909,6.5,6.5,6.5s6.5-2.909,6.5-6.5S20.091,12,16.5,12S10,14.909,10,18.5"
});

var _ref5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#BBDEFB",
  d: "M29.5 17A8.5 8.5 0 1 0 29.5 34A8.5 8.5 0 1 0 29.5 17Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#BBDEFB",
  d: "M37 26.893A7 7 0 1 0 37 40.893 7 7 0 1 0 37 26.893zM11 27A7 7 0 1 0 11 41 7 7 0 1 0 11 27z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#BBDEFB",
  d: "M17.5 20A6.5 6.5 0 1 0 17.5 33A6.5 6.5 0 1 0 17.5 20Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#BBDEFB",
  d: "M25 24.893A7 7 0 1 0 25 38.893A7 7 0 1 0 25 24.893Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#BBDEFB",
  d: "M7,37c0,2.209,1.791,4,4,4h25c2.209,0,4-1.791,4-4v-1c0-2.209-1.791-4-4-4H11c-2.209,0-4,1.791-4,4V37z"
}));

var SvgPartlyCloudy = function SvgPartlyCloudy(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPartlyCloudy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/partly-cloudy.c2e06f02.svg";
export { ForwardRef as ReactComponent };